/**import React from "react";
import { Container, Row,Col } from "react-bootstrap";
import Nav from 'react-bootstrap/Nav';
import asavaLogo from '../Assets/asava-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';
import Navbar from 'react-bootstrap/Navbar';
import "./front.css";

const Footer = () =>{
    return (
        <Container fluid className="footer-shadow" style={{ padding: '2% 2%'}}>
            <Row>
                <Navbar.Brand href="/">
                    <img src={asavaLogo} height={"80px"} width={"80px"} 
                        style={
                            {borderRadius : '30px',
                            }} 
                        alt="asava-logo"
                    />
                    <h5 style={{fontFamily:"Lavishly Yours "}}>ASAVA PHARMACEUTICALS</h5>
                </Navbar.Brand>
            </Row>
            <Row style={{padding:"2% 2%", marginRight: "40px"}}>
                <Nav className="justify-content-end" activeKey="/home">
                    <Nav.Item>
                        <Nav.Link href="/">Home</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="/products">About</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="/contactinfo">Contact Us</Nav.Link>
                    </Nav.Item>
                </Nav> 
            </Row>
            <Row style={{marginBottom: "50px",padding:"2% 2%"}} className="d-flex align-items-left">
                    <Col sm={4}>
                        <div>
                        <h4 style={{fontFamily:"serif", alignContent: "left"}}> Healing through Excellence </h4>
                        <p className="mb-0" 
                            style={{ textAlign: 'justify' , 
                                fontFamily:"serif",
                                fontSize: "20px",
                                justifyContent: ""
                            }}
                        >
                            Asava is dedicated to developing cutting-edge solutions that 
                            enhance patient care and promote well-being. By harnessing 
                            advanced research and state-of-the-art technology, the company 
                            continuously strives to deliver effective and affordable healthcare 
                            solutions, making a meaningful impact on the lives of individuals and 
                            communities alike.
                        </p>
                        </div>
                    </Col>
                    <Col sm ={5} style={{marginTop: "50px"}}>
                            <p style={{ cursor: 'pointer', transition: 'color 0.3s'}} >
                                <FontAwesomeIcon icon={faPhone} style={{ marginRight: '5px' }} />
                                <a href="tel:+919278077911">+919278077911</a>
                            </p>
                            
                            <p style={{ cursor: 'pointer', transition: 'color 0.3s'}} >
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '5px' }} />
                               <a href="mailto:asavapharma@gmail.com"> asavapharma@gmail.com</a>
                            </p>
                            
                    </Col>
                    <Col sm = {3} style={{marginTop: "30px"}}>       
                        <div style={{display: "flex", 
                            padding : "10px 10px",
                            alignContent: "left"
                            }}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: '5px' }} />
                            <p style={{ cursor: 'pointer', transition: 'color 0.3s',textAlign: "justify"}} >
                                <a href="https://maps.app.goo.gl/Zn6LYuU5frbmEiXQ6">H.No - 19, Kh.No - 367/1,<br/> 
                                Nijampur Malhaur Chinhat,<br/>
                                Secretariat, Lucknow,
                                Uttar <br/>Pradesh,India,
                                226001
                                </a>
                            </p>
                        </div>
                        <div style={{display: "flex", alignContent: "left"}}>
                        <FontAwesomeIcon className = "fa-lg" icon={faBuilding} style={{ marginRight: '5px' }} />
                            <h6>
                                <a href="https://www.falconebiz.com/company/ASAVA-PHARMACEUTICALS-PRIVATE-LIMITED-U47721UP2025PTC217626">CIN: U47721UP2025PTC217626</a>
                            </h6>
                        </div>
                    </Col>
                </Row>  
        </Container>
    ) 

}

export default Footer;**/

import React from "react";
import asavaLogo from '../Assets/asava-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import "./front.css";

const Footer = () => {
    return (
        <div className="footer-wrap">

            {/* Decorative circles */}
            <div className="footer-circle-top" />
            <div className="footer-circle-bottom" />

            {/* Top bar — logo + nav */}
            <div className="footer-top">
                <div className="footer-brand">
                    <img src={asavaLogo} alt="asava-logo" className="footer-logo" />
                    <div>
                        <div className="footer-brand-name">ASAVA PHARMACEUTICALS</div>
                        <div className="footer-brand-tagline">Healing Through Excellence</div>
                    </div>
                </div>
                <nav className="footer-nav">
                    <Link to="/">Home</Link>
                    <Link to="/overview">About Us</Link>
                    <Link to="/products">Products</Link>
                    <Link to="/contactinfo">Contact Us</Link>
                </nav>
            </div>

            {/* Body — three columns */}
            <div className="footer-body">

                {/* About blurb */}
                <div className="footer-about">
                    <h4>
                        Healing Through Excellence
                        <span className="footer-underline" />
                    </h4>
                    <p>
                        Asava is dedicated to developing cutting-edge solutions that
                        enhance patient care and promote well-being. By harnessing
                        advanced research and state-of-the-art technology, the company
                        continuously strives to deliver effective and affordable healthcare
                        solutions, making a meaningful impact on the lives of individuals
                        and communities alike.
                    </p>
                </div>

                {/* Contact */}
                <div className="footer-contact">
                    <h5 className="footer-section-label">Get in Touch</h5>

                    <a href="tel:+919278077911" className="footer-contact-item">
                        <div className="footer-icon icon-phone">
                            <FontAwesomeIcon icon={faPhone} />
                        </div>
                        <div>
                            <div className="footer-item-label">Phone</div>
                            <div className="footer-item-val">+91 92780 77911</div>
                        </div>
                    </a>

                    <a href="mailto:asavapharma@gmail.com" className="footer-contact-item">
                        <div className="footer-icon icon-mail">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <div>
                            <div className="footer-item-label">Email</div>
                            <div className="footer-item-val">asavapharma@gmail.com</div>
                        </div>
                    </a>
                </div>

                {/* Address */}
                <div className="footer-address">
                    <h5 className="footer-section-label">Location & Registration</h5>

                    
                        <a href="https://maps.app.goo.gl/Zn6LYuU5frbmEiXQ6"
                        target="_blank"
                        rel="noreferrer"
                        className="footer-contact-item"
                    >
                        <div className="footer-icon icon-map">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </div>
                        <div>
                            <div className="footer-item-label">Registered Address</div>
                            <div className="footer-item-val">
                                H.No - 19, Kh.No - 367/1,<br />
                                Nijampur Malhaur Chinhat,<br />
                                Secretariat, Lucknow, UP 226001
                            </div>
                        </div>
                    </a>

                    
                    < a href="https://www.falconebiz.com/company/ASAVA-PHARMACEUTICALS-PRIVATE-LIMITED-U47721UP2025PTC217626"
                        target="_blank"
                        rel="noreferrer"
                        className="footer-contact-item"
                    >
                        <div className="footer-icon icon-cin">
                            <FontAwesomeIcon icon={faBuilding} />
                        </div>
                        <div>
                            <div className="footer-item-label">Corporate Identity Number</div>
                            <div className="footer-item-val">U47721UP2025PTC217626</div>
                        </div>
                    </a>
                </div>

            </div>

            {/* Bottom bar */}
            <div className="footer-bottom">
                <span className="footer-copy">
                    © 2025 Asava Pharmaceuticals Pvt. Ltd. All rights reserved.
                </span>
                <span className="footer-cin">CIN: U47721UP2025PTC217626</span>
            </div>

        </div>
    );
};

export default Footer;